/**
 * ReviewQueueDrawer — public entry point for the pipeline Review-queue drawer
 * (SE-5499). Mount once near the pipeline board; open it via
 * `useReviewQueueDrawerState().open()`.
 * @module features/player-kanban/components/organisms/ReviewQueueDrawer
 */

export { default } from "./ReviewQueueDrawerContainer";
